import FolderPath from "./FolderPath";
import { useState, useEffect } from "react";
import { getCurrentFiscalYear, getFiscalMonths } from "./Delivery";

export default function Learning() {    
  const trackBaseUrl = "tracks/learning/technology/";   
    
  const START_FY = 23;

  const [fiscalYears, setFiscalYears] = useState(() => {
    const currentFY = parseInt(getCurrentFiscalYear(), 10);
    return Array.from({ length: currentFY - START_FY + 1 }, (_, i) =>
      (START_FY + i).toString().padStart(2, "0")
    );
  });

  useEffect(() => {
    const updateFY = () => {
      setFiscalYears(prev => {
        const last = parseInt(prev[prev.length - 1], 10);
        const current = parseInt(getCurrentFiscalYear(), 10);

        if (current > last) {
          const missing = Array.from(
            { length: current - last },
            (_, i) => (last + i + 1).toString().padStart(2, "0")
          );
          return [...prev, ...missing];
        }
        return prev;
      });
    };

    updateFY();
    const interval = setInterval(updateFY, 3600000);
    return () => clearInterval(interval);
  }, []);

  const foldersDetail = {
      level1: ["Portal Development","Digital Learning"],
      level2: ["Artifacts","Archives"],
      level3: fiscalYears,    
      level4: getFiscalMonths()
  }

  return <FolderPath trackBaseUrl={trackBaseUrl} foldersDetail={foldersDetail} />;    
}